var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebSite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5261 4.22803H9.6258C9.30879 4.22803 9.05176 4.48506 9.05176 4.80206C9.05176 5.11907 9.30879 5.3761 9.6258 5.3761H32.5259C33.4225 5.3761 34.1518 6.10554 34.1518 7.00197V28.2981C34.1518 29.1947 33.4224 29.924 32.5259 29.924H14.3588C14.0418 29.924 13.7848 30.181 13.7848 30.498C13.7848 30.815 14.0418 31.072 14.3588 31.072H32.5259C34.0556 31.072 35.2999 29.8277 35.2999 28.2981V7.00197C35.3 5.47235 34.0556 4.22803 32.5261 4.22803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0627 29.9242H2.77394C1.87738 29.9242 1.14808 29.1948 1.14808 28.2983V7.00214C1.14808 6.10565 1.87738 5.37635 2.77394 5.37635H7.32963C7.64664 5.37635 7.90367 5.11932 7.90367 4.80231C7.90367 4.4853 7.64664 4.22827 7.32963 4.22827H2.77394C1.24432 4.22827 0 5.47259 0 7.00214V28.2983C0 29.8279 1.24432 31.0722 2.77394 31.0722H12.0626C12.3797 31.0722 12.6367 30.8152 12.6367 30.4982C12.6367 30.1812 12.3797 29.9242 12.0627 29.9242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4482 11.6295H3.85169C3.53468 11.6295 3.27765 11.8865 3.27765 12.2036V27.1321C3.27765 27.4491 3.53468 27.7062 3.85169 27.7062H24.2772C24.5943 27.7062 24.8513 27.4491 24.8513 27.1321C24.8513 26.8151 24.5943 26.5581 24.2772 26.5581H4.42572V12.7776H30.8742V26.5581H26.5734C26.2564 26.5581 25.9994 26.8151 25.9994 27.1321C25.9994 27.4491 26.2564 27.7062 26.5734 27.7062H31.4482C31.7652 27.7062 32.0223 27.4491 32.0223 27.1321V12.2036C32.0223 11.8865 31.7652 11.6295 31.4482 11.6295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1774 9.77385C30.8794 9.77385 31.4485 9.20474 31.4485 8.50271C31.4485 7.80068 30.8794 7.23157 30.1774 7.23157C29.4754 7.23157 28.9062 7.80068 28.9062 8.50271C28.9062 9.20474 29.4754 9.77385 30.1774 9.77385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.349 9.77385C27.051 9.77385 27.6201 9.20474 27.6201 8.50271C27.6201 7.80068 27.051 7.23157 26.349 7.23157C25.6469 7.23157 25.0778 7.80068 25.0778 8.50271C25.0778 9.20474 25.6469 9.77385 26.349 9.77385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5213 9.77385C23.2233 9.77385 23.7924 9.20474 23.7924 8.50271C23.7924 7.80068 23.2233 7.23157 22.5213 7.23157C21.8192 7.23157 21.2501 7.80068 21.2501 8.50271C21.2501 9.20474 21.8192 9.77385 22.5213 9.77385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.3,
    height: 35.3,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebSite);
export default __webpack_public_path__ + "static/media/web_site.7d995fece42bdf0c688e1216502f33af.svg";
export { ForwardRef as ReactComponent };